import cx from 'classnames'
import type { Ref, SVGAttributes } from 'react'
import { type IconName, iconsMap } from '@/components/Icon/icons.g'
import styles from './Icon.module.css'

/**
 * Name of an icon.
 */
export type { IconName } from './icons.g'

export interface IconProps extends SVGAttributes<SVGElement> {
  name: IconName
  auto?: boolean
  color?: string
  rotate?: number
  size?: number
  ref?: Ref<SVGSVGElement>
}

/**
 * An SVG icon from the design system.
 */
export function Icon({
  name,
  size,
  className,
  color,
  auto,
  style,
  rotate,
  ...rest
}: IconProps) {
  // SAFETY: the generated map has an entry for every `IconName`.
  const { Component } = iconsMap.get(name)!
  return (
    <Component
      style={{
        color,
        transform: rotate ? `rotate(${rotate}deg)` : undefined,
        ...(size ? { fontSize: size } : undefined),
        ...style,
      }}
      className={cx(styles.icon, !auto && styles.defaultSize, className)}
      {...rest}
    />
  )
}
